<template>
	<vxe-modal v-model="modal" width="1000" height="600" @show="show" @hdie="hide" :title="title" destroy-on-close
		:showFooter="true">
		<template #default>
			<vxe-toolbar>
				<template #buttons>
					<vxe-button @click="salemanscoreExport">导出</vxe-button>
				</template>
			</vxe-toolbar>
			<vxe-table ref="salemanscore" footer-cell-class-name="footerCellColor" :show-footer="true" border
				show-overflow height="450" :data="data">
				<vxe-column type="seq" width="80"></vxe-column>
				<vxe-column field="targetname" title="客服名称"></vxe-column>
				<vxe-column field="score" title="积分"></vxe-column>
				<vxe-column title="操作" width="60" align="center">
					<template #default="{ row }">
						<el-button type="text" size="mini" @click="detail(row)">明细</el-button>						
					</template>
				</vxe-column>
			</vxe-table>
			
			
			<detailIndex :currentrow="currentrow" :commit_time="commit_time" ref="detailIndex" />
			
			
		</template>
		<template #footer>
			<vxe-button status="" content="返回" @click="cancel"></vxe-button>
		</template>
	</vxe-modal>

</template>
<style scoped>

</style>
<script>
	import detailIndex from '../detail/index.vue'
	export default {
		props: {
			title: {
				type: String,
				default: () => {
					return '积分统计'
				}
			},
			commit_time: {
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				modal: false,
				loading: false,
				tableData: [],
				data: [],
				currentrow:null

			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			cancel() {
				this.modal = false
			},
			hide() {
				this.$emit('hide')

			},
			show() {
				this.data = []
				this.$api.salemanscore.statistics({
					commit_time: this.commit_time
				}).then((res) => {
					this.data = res
					console.log(res)
					// let groupedData = this.$Lodash.groupBy(res, 'transDate')
					// let paymentsummaryData = []
					// for (let i in groupedData) {
					// 	let obj = {}
					// 	obj.date = i
					// 	groupedData[i].forEach((item) => {
					// 		if (item.abs == '转账') {
					// 			obj.payment = parseFloat(item.amt)
					// 		} else if (item.abs == '退汇') {
					// 			obj.remittance = parseFloat(item.amt)
					// 		} else {
					// 			obj.abouchement = parseFloat(item.amt)
					// 		}
					// 	})
					// 	obj.datepayment = obj.payment?obj.payment:0 - obj.remittance?obj.remittance:0
					// 	paymentsummaryData.push(obj)
					// }
					// this.paymentsummaryData = paymentsummaryData
					// console.log(paymentsummaryData)
					// this.paymentsummaryShow = true
				})
			},
			salemanscoreExport() {
				this.$refs.salemanscore.exportData({
					type: 'xlsx'
				})
			},
			modalShow() {
				this.modal = true
			},
			detail(row){
				this.currentrow = row
				this.$refs.detailIndex.modalShow()
			}
		},
		components: {
			detailIndex
		}
	}
</script>